import React, { FC, useEffect, useState } from "react";
import ButtonComponent from "../../../../shared/components/ButtonComponent";
import { SearchInput } from "../../../../shared/components/SearchInput";
import { PlusOutlined, RightOutlined, DownOutlined } from "@ant-design/icons";
import { Space, Table } from "antd";
import faker from "faker";
import ToggleSwitch from "../../../../shared/components/ToggleSwitch";
import CardMenu from "../../../../shared/components/CourseComponents/CardMenu";
import InstituteSectionForm from "./InstituteSectionForm";
import "./instituteSection.scss";
import { Sections } from "../../../../models/InstituteModel/sections.model";
import SectionService from "../../../../services/InstituteService/section.service";
import PaginationComponent from "../../../../shared/components/PaginationComponent";
import DeleteAlert from "../../../../shared/components/DeleteAlert";
import { useLocation } from "react-router-dom";
import { Institutes } from "../../../../models/InstituteModel/institutes.model";
export const InstituteSection: FC = (props: any) => {
  const { user } = props;
  const [showForm, setFormVisibility] = useState(false);
  const [currentSection, setCurrentSection] = useState<any>(null);
  const [sections, setSections] = useState<Sections[]>([]);
  const [paginationMeta, setPaginationMeta] = useState<any>([]);
  const [currentPageNumber, setCurrentPageNumber] = useState<number>(1);
  const [deleteVisible, setDeleteVisibility] = useState(false);
  const [loading, setLoading] = useState<boolean>(true);
  const { state }: { state: Institutes } = useLocation();

  const fetchSections = (params: any) => {
    setLoading(true);
    SectionService.fetchSections(
      { ...params, institute_id: state?.id },
      (sections, meta) => {
        setSections(sections);
        setPaginationMeta(meta);
        setLoading(false);
      },
      () => { },
      () => { }
    );
  };
  const handlePageChange = (page: number, pageSize: any) => {
    fetchSections({ page });
    setCurrentPageNumber(page);
  };

  const handleSearch = (value: string) => {
    fetchSections({ page: currentPageNumber, search: value });
  };

  useEffect(() => {
    fetchSections({ page: currentPageNumber });
  }, []);

  const handleToggle = (id: any, value: boolean) => {
    SectionService.updateSection(
      id,
      {
        isActive: value,
      },
      () => {
        fetchSections({ page: currentPageNumber });
      },
      () => { },
      () => { }
    );
  };
  const handleDelete = () => {
    SectionService.deleteSection(
      currentSection?.id,
      () => {
        fetchSections({ page: currentPageNumber });
        setDeleteVisibility(false);
      },
      () => { },
      () => { }
    );
  };
  return (
    <div className="institute-section__container">
      <InstituteSectionForm
        visible={showForm}
        closeHandler={() => {
          setFormVisibility(false);
          setCurrentSection(null);
        }}
        data={currentSection}
        refreshList={() => fetchSections({ page: currentPageNumber })}
      />
      <DeleteAlert
        title={currentSection?.name}
        detail={""}
        visible={deleteVisible}
        setVisible={setDeleteVisibility}
        deleteText="section"
        deleteWarning="This section will be deleted permanently"
        handleDelete={handleDelete}
      />
      <div className="header__wrapper">
        <div className="header__left">
          <SearchInput
            placeholder={"Search by any branch, class, section ..."}
            onChange={handleSearch}
          />
        </div>
        {user?.roleName === 'admin' && <div className="header__right">
          <ButtonComponent
            buttonContent="Add Section"
            type="primary"
            iconLeft={<PlusOutlined />}
            onClick={() => {
              setCurrentSection(null);
              setFormVisibility(true);
            }}
          />
        </div>
        }
      </div>

      <Table
        className="institute__table"
        pagination={false}
        loading={loading}
        onRow={(record) => {
          return {
            onClick: (event) => setCurrentSection(record),
          };
        }}
        columns={[
          {
            title: "Branch",
            dataIndex: "branch",
            key: "branch",
            render: (text) => <p>{text?.name}</p>,
          },
          {
            title: "Board",
            dataIndex: "board",
            key: "board",
            render: (text) => <p>{text?.acronym}</p>,
          },
          {
            title: "Class",
            dataIndex: "classRoom",
            key: "classRoom",
            render: (text) => <p>{text?.name}</p>,
          },
          {
            title: "Section",
            dataIndex: "name",
            key: "name",
          },
          {
            title: "Section ID",
            dataIndex: "id",
            key: "id",
          },
          user?.roleName === 'admin' ? {
            dataIndex: "isActive",
            key: "isActive",
            render: (text, record) => (
              <Space size="large" className="float-right">
                <ToggleSwitch
                  checked={text}
                  handleChange={(value) => handleToggle(record?.id, value)}
                />
                <CardMenu
                  menuText="Section"
                  handleEdit={() => setFormVisibility(true)}
                  handleDelete={() => setDeleteVisibility(true)}
                />
              </Space>
            ),
          } : {},
        ]}
        dataSource={sections}
        expandable={{
          expandIcon: ({ expanded, onExpand, record }) =>
            expanded ? (
              <DownOutlined
                className="expandable__icon"
                onClick={(e) => onExpand(record, e)}
              />
            ) : (
              <RightOutlined
                className="expandable__icon"
                onClick={(e) => onExpand(record, e)}
              />
            ),

          expandedRowRender: (record) => (
            <div className="expandable__wrapper">
              <div className="subjects__wrapper">
                <p className="subjects__title">Configured Subjects</p>
                <p className="subjects__name">
                  {record.classRoomSubjects?.map((value, index) => {
                    return (
                      <Space>
                        <p>{value?.name}</p>
                        <p className="id">(ID: {value?.id})</p>
                        <p>
                          {index !==
                            (record?.classRoomSubjects?.length &&
                              record?.classRoomSubjects?.length - 1)
                            ? ", "
                            : ""}
                          &nbsp;
                        </p>
                      </Space>
                    );
                  })}
                </p>
              </div>
              <div className="exams__wrapper">
                <p className="exams__title">Configured Exams</p>

                <p className="exams__name">
                  {record.exams?.map((value, index) => {
                    return (
                      <Space>
                        <p>{value?.acronym}</p>
                        <p className="id">(ID: {value?.id})</p>
                        <p>
                          {index !==
                            (record?.exams?.length && record?.exams?.length - 1)
                            ? ", "
                            : ""}
                          &nbsp;
                        </p>
                      </Space>
                    );
                  })}
                </p>
              </div>
            </div>
          ),
        }}
      />
      <PaginationComponent
        handlePageChange={handlePageChange}
        paginationMeta={paginationMeta}
      />
    </div>
  );
};
